import ReactJsonViewer from "app/lib/utils/ReactJsonViewer";
import React from "react";

const LogsDetails = ({ data = {} }) => {

    return (
        <div style={{ textAlign: "left", width: '100%', margin: "15px 0px", overflow: "auto" }}>
            {Object.keys(data).length ? Object.keys(data).map(k => (
                <div className="data-item">
                    <ReactJsonViewer src={data[k]} collapsed={true} />
                </div>
            )) : ""}
        </div>
    )
}

export default LogsDetails;